import React, { createContext, useState } from "react";
export const AccessDeviceImportContext = createContext({
    isImporting: false,
    setIsImporting: () => { },
});
export const AccessDeviceImportProvider = ({ children }) => {
    const [isImporting, setIsImporting] = useState(false);
    return (React.createElement(AccessDeviceImportContext.Provider, { value: { isImporting, setIsImporting } }, children));
};
